import { Component, OnInit, Input } from "@angular/core";
import { PopoverComponentComponent } from "../popover-component/popover-component.component";
import { PopoverController } from "@ionic/angular";
import { ToastComponent } from "src/app/core-files/loaders/toast-messages";
import { LoginAlert } from "src/app/core-files/login-alert-dialog";
import { MatDialog } from "@angular/material/dialog";
import { SubscriptionExpiredComponent } from "../subscription-expired/subscription-expired.component";
import { EncryptionService } from "src/app/services/encryption.service";
import { SharedServices } from "src/app/services/shared.service";

@Component({
  selector: "app-any-report",
  templateUrl: "./any-report.component.html",
  styleUrls: ["./any-report.component.scss"],
  standalone: false
})
export class AnyReportComponent implements OnInit {
  @Input() propDate;
  @Input() PropertyId: any;
  @Input() isMyPost;
  @Input() IsReport;
  @Input() StatusTypeId;
  isLoggedIn: any;
  constructor(
    private popoverController: PopoverController,
    private toastComponent: ToastComponent,
    private dialog: MatDialog,
    private encryptionService: EncryptionService,
    private sharedServices: SharedServices
  ) {}

  ngOnInit() {
    // this.isLoggedIn = this.encryptionService.decryptUsingAES256(JSON.parse(localStorage.getItem("lg_d_i")));
    this.isLoggedIn = this.sharedServices.getLogedIn();
  }

  async anyReport(ev: any, PropertyId, StatusTypeId) {
    if (this.isLoggedIn) {
      const popover = await this.popoverController.create({
        component: PopoverComponentComponent,
        event: ev,
        componentProps: { PropertyId: PropertyId, StatusTypeId: StatusTypeId },
        translucent: true,
      });
      return await popover.present();
    } else {
      this.dialog.open(SubscriptionExpiredComponent);
    }
  }
  calculateDiff(propDate) {
    let date = new Date(propDate);
    let currentDate = new Date();

    let days = Math.floor(
      (currentDate.getTime() - date.getTime()) / 1000 / 60 / 60 / 24
    );
    return days;
  }
  Reported() {
    this.toastComponent.showToast(
      "You already reported this property",
      "danger"
    );
  }
}
